import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'transition-all inline-flex items-center rounded-full px-2.5 py-2 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default: 'bg-default-badge-static-background text-default-badge-static-text [&>svg~*]:text-default-badge-static-icon',
        ghost: 'bg-badge-ghost-static-background text-badge-ghost-static-text [&>svg~*]:text-badge-ghost-static-icon',
        destructive: 'bg-badge-destructive-static-background text-badge-destructive-static-text [&>svg~*]:text-badge-destructive-static-icon',
        success: 'bg-badge-success-static-background text-badge-success-static-text [&>svg~*]:text-badge-success-static-icon',
        warning: 'bg-badge-warning-static-background text-badge-warning-static-text [&>svg~*]:text-badge-warning-static-icon',
        info: 'bg-badge-info-static-background text-badge-info-static-text [&>svg~*]:text-badge-info-static-icon',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

export interface BadgeProps extends React.HTMLAttributes<HTMLDivElement>, VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return <div className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { Badge, badgeVariants };
